(function() {
    'use strict';

    angular
        .module('dialog-manager')
        .controller('DialogAsyncCtrl', DialogAsyncCtrl);

    function DialogAsyncCtrl(dialogOptions, $timeout, close, dialogId, $compile, $element, $scope) {
        const vm = this;
        vm.show = false;
        vm.dialogOptions = dialogOptions;
        vm.options =  dialogOptions;

        vm.dismiss = dismiss;

        $timeout(function () {
            vm.show = true;
            const asyncPanelWrapper = $element.find('.async-panel-wrapper');
            asyncPanelWrapper.html(dialogOptions.async_panel_template);

            const cloneElement = $compile(asyncPanelWrapper.contents())($scope);

            $scope.$on('$destroy', function() {
                if (cloneElement) {
                    cloneElement.off();
                }
            });
        });

        function dismiss() {
            close(false);
        }
    }
})();